import React from "react";

import { InputNumericRangeSlider } from "./InputNumericRangeSlider";

export interface IInputNumericRange {
  value: [number, number];
  min: number;
  max: number;
  step?: number;
  unit?: string;
  hideEdges?: boolean;
  disabled?: boolean;
  disabledInput?: boolean;
  onChangeHandler: any;
  variant?: string;
}
const InputNumericRange: React.FC<IInputNumericRange> = ({
  value = [10, 90],
  min = 0,
  max = 100,
  step,
  hideEdges = false,
  disabled = false,
  disabledInput = false,
  onChangeHandler = (e: any) => console.log(e),
  variant = "slider",
  unit,
}) => {
  let Component;
  switch (variant) {
    default:
      Component = InputNumericRangeSlider;
      break;
  }

  return (
    <Component
      {...{
        value,
        min,
        max,
        hideEdges,
        disabled,
        disabledInput,
        step,
        unit,
        onChangeHandler,
      }}
      data-testid="input-range"
    />
  );
};

export default InputNumericRange;
